import { useTranslations } from "@zapier/i18n";
import style from "./AppDetailsEmpty.module.css";
import { Icon } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";

interface Props {
  type: "personal" | "shared" | "private";
}

export function AppDetailsEmpty({ type }: Props) {
  const t = useTranslations("app-details-empty");

  let header = t("messages.no-connections-added");
  if (type === "personal") {
    header = t("messages.no-personal-connections");
  } else if (type === "private") {
    header = t("messages.no-admin-only-connections");
  }

  return (
    <div className={style.emptyTableDisplay}>
      <div className={style.iconWrapper}>
        <Icon name="navConnectedAssets" size="36" color="GrayWarm6" />
      </div>
      <div className={style.textWrapper}>
        <Text tag="h3" type="ParagraphHeader3">
          {header}
        </Text>
        <Text tag="p" type="Body1Multiline" color="TextWeaker">
          {t("messages.add-connection-help")}
        </Text>
      </div>
    </div>
  );
}
